import angular from 'angular';

/* X-editable wrapper for cxAssignedToSelect */
angular.module('cxTaskflow').directive('editableAssignedTo', [
  'editableDirectiveFactory',
  function(editableDirectiveFactory) {
    return editableDirectiveFactory({
      directiveName: 'editableAssignedTo',
      inputTpl: '<cx-assigned-to-select></cx-assigned-to-select>',
      autosubmit: function() {
        var self = this;
        self.inputEl.bind('change', function() {
          self.scope.$apply(function() {
            self.scope.$form.$submit();
          });
        });
      },
      handleEmpty: function() {
        var self = this;
        var val = self.scope.$parent.$eval(self.attrs['editableAssignedTo']);
        var isEmpty =
          val === null ||
          val === undefined ||
          val === '' ||
          (angular.isArray(val) && val.length === 0) ||
          val.assignedType === 0;
        self.elem.toggleClass('editable-empty', isEmpty);
      },
    });
  },
]);
